<div class="absence-form-wrapper">
  <!-- open absence msg -->
  <p-message *ngIf="openAbsence" [severity]="'info'">
    {{ 'info.open-absence' | translate: {date: moment(openAbsence.begin).format('DD/MM/YYYY')} }}
  </p-message>
  <!-- form -->
  <form [formGroup]="form" class="absence-form" *ngIf="form">
    <div class="employee-all-day">
      <!-- employee -->
      <app-form-input-text [field]="'employee'" [formControl]="f['employee']" formControlName="employee"></app-form-input-text>
      <!-- isAllDay -->
      <div class="all-day">
        <label [innerHTML]="'all-day' | translate" class="input-label"></label>
        <p-selectbutton [options]="allDayOptions" formControlName="isAllDay" optionLabel="name" optionValue="value"
          [allowEmpty]="false" />
      </div>
    </div>
    <div>
      <!-- begin -->
      <app-form-input-date [field]="f['isAllDay'].value ? 'startDate' : 'date'" [formControl]="f['begin']" 
        formControlName="begin"></app-form-input-date>
      <!-- end -->
      <app-form-input-date [field]="'endDate'" [formControl]="f['end']" formControlName="end"
        *ngIf="f['isAllDay'].value"></app-form-input-date>
    </div>
    <div *ngIf="!f['isAllDay'].value">
      <!-- beginHour -->
      <app-form-input-date [field]="'hour-begin'" [formControl]="f['beginHour']" formControlName="beginHour"
        [timeOnly]="true"></app-form-input-date>
      <!-- endHour -->
      <app-form-input-date [field]="'hour-end'" [formControl]="f['endHour']" formControlName="endHour"
        [timeOnly]="true"></app-form-input-date>
    </div>
    <!-- type -->
    <app-form-input-dropdown [options]="absenceTypes" [optionsField]="'name'" [noLabel]="false" [appendTo]="'body'" [clearable]="false"
      [filter]="false" [field]="'reason'" [formControl]="f['type']" formControlName="type"></app-form-input-dropdown>
    <!-- comments -->
    <app-form-input-text-area [field]="'comments'" [formControl]="f['comments']" 
      formControlName="comments" [rows]="15"></app-form-input-text-area>
  </form>
  <!-- buttons -->
  <div class="buttons">
    <p-button [label]="'button.delete' | translate" severity="danger" (click)="remove()" *ngIf="absence && absence.isAllDay"/>
    <p-button [label]="'button.cancel' | translate" severity="secondary" (click)="cancel()"/>
    <p-button [label]="'button.save' | translate" severity="contrast" (click)="save()"/>
  </div>
</div>
    